import { render } from "./cpt-page-option.vue?vue&type=template&id=14c98f87"
import script from "./cpt-page-option.vue?vue&type=script&lang=js"
export * from "./cpt-page-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__